<template>
  <div>

    <my-upload-table ref="uploadtable" :count="myValue" :accept="acceptString"></my-upload-table>
    <el-input readonly v-model="myValue">
      <template slot="append">
        <el-button @click="$refs.uploadtable.show(id)" size="small" type="primary" icon="el-icon-upload"></el-button>
      </template>
    </el-input>
  </div>
</template>
<script>

export default {
  props: {
    value: {},
    accept:{},
    myid: {},
  },



  data() {
    return {
      id: this.myid,
      myValue: this.value,
    };
  },

  watch: {
    value(newValue) {
      this.myValue = newValue
    },
    myValue(newValue) {
      this.$emit('input', newValue)
    },
    myid: {
      immediate: true,
      handler: function (newVal) {
        this.id = newVal
      }
    }
  },
  computed: {
    acceptString() {
      if (this.accept === "image") return "image/jpg,image/jpeg,image/png";
      if (this.accept === "audio") return "audio/mp3";
    },
  },
}
</script>